import { useRef } from "react";

export default function PanitiaSmbjmPage() {
  const tableRef = useRef<HTMLTableElement | null>(null);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div>
      <button onClick={handlePrint} className="print:hidden">
        Print Tabel Saja
      </button>

      <table ref={tableRef}>
        <thead>
          <tr>
            <th className="border border-black">Nama</th>
          </tr>
        </thead>
        <tbody>
          {Array(100)
            .fill(null)
            .map((_, index) => {
              return (
                <tr key={index}>
                  <td
                    className="
                  border border-black"
                  >
                    lorem{index + 1}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
}
